import styled from 'styled-components';

export const StyledAuthFormIframe = styled.form`
    display: flex;
    flex-direction: column;
    padding: 0 var(--spacing-1);
    row-gap: var(--spacing-4);
`;
